import { render, staticRenderFns } from "./NewPagination.vue?vue&type=template&id=131fe8d4&scoped=true&"
import script from "./NewPagination.vue?vue&type=script&lang=js&"
export * from "./NewPagination.vue?vue&type=script&lang=js&"
import style0 from "./NewPagination.vue?vue&type=style&index=0&id=131fe8d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131fe8d4",
  null
  
)

export default component.exports